import type {
  ChartReportValidationResponse,
  ListReportValidationResponse,
  PivotReportValidationResponse,
  ReportValidationResponse,
  TabularReportValidationResponse,
  TileReportValidationResponse,
} from "../../../../../../../api/types/svTypes.ts";

export const getInvalidFieldsCount = (result: ReportValidationResponse | undefined): number => {
  if (!result) {
    return 0;
  }

  switch (result.reportType) {
    case "Pivot": {
      return getPivotInvalidFieldsCount(result);
    }
    case "Tabular": {
      return getTabularInvalidFieldsCount(result);
    }
    case "Chart": {
      return getChartInvalidFieldsCount(result);
    }
    case "Tile":
    case "List": {
      return getFlatInvalidFieldsCount(result);
    }
  }
};

function getPivotInvalidFieldsCount(result: PivotReportValidationResponse) {
  let invalidFields = (result.conditions?.filter((c) => c.valid === false) || []).length;
  invalidFields += (result.columns?.filter((c) => c.valid === false) || []).length;
  invalidFields += (result.rows?.filter((c) => c.valid === false) || []).length;
  invalidFields += (result.measures?.filter((c) => c.valid === false) || []).length;
  return invalidFields;
}

function getTabularInvalidFieldsCount(result: TabularReportValidationResponse) {
  let invalidFields = (result.conditions?.filter((c) => c.valid === false) || []).length;
  invalidFields += (result.fields?.filter((c) => c.dimension?.valid === false || c.measure?.valid === false) || [])
    .length;
  return invalidFields;
}
function getChartInvalidFieldsCount(result: ChartReportValidationResponse) {
  let invalidFields = (result.conditions?.filter((c) => c.valid === false) || []).length;
  invalidFields += (result.arguments?.filter((c) => c.valid === false) || []).length;
  invalidFields += (result.measures?.filter((c) => c.valid === false) || []).length;
  return invalidFields;
}

const getFlatInvalidFieldsCount = (result: TileReportValidationResponse | ListReportValidationResponse): number => {
  let invalidFields = (result.conditions?.filter((condition) => condition.valid === false) || []).length;
  invalidFields += (result.fields?.filter((field) => field.valid === false) || []).length;
  return invalidFields;
};
